import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const getCategories = () => api.get("/categories").then(r => r.data);
export const getListings = (params = {}) => api.get("/listings", { params }).then(r => r.data);
export const getListing = (slug) => api.get(`/listings/${slug}`).then(r => r.data);
export const getArticles = () => api.get("/articles").then(r => r.data);
export const getArticle = (slug) => api.get(`/articles/${slug}`).then(r => r.data);
export const postInquiry = (data) => api.post("/inquiries", data).then(r => r.data);
export const postSubscriber = (data) => api.post("/subscribers", data).then(r => r.data);

export const CATEGORY_LABELS = {
  hotels: "Hotels",
  villas: "Villas",
};

export const CATEGORY_ORDER = ["hotels", "villas"];
